import React, { useState,useEffect } from "react";
import Cookies from "js-cookie";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
function  AllCompaniesPage() {
    const ID = Cookies.get("log_id");
    const [companies,setCompanies] = useState([]);
    function all_Companies() {
        axios.get(`${url.path}/all_companies/`)
        .then((res) =>{
            if (res.data.status){
                var cmp = res.data.companies;
                setCompanies([])
                cmp.map((p)=>{
                    setCompanies((prevState) =>[
                        ...prevState, p
                    ])
            })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        all_Companies();
    }, [])
        
        const itemsPerPage = 3;
        const [searchTerm, setSearchTerm] = useState("");
        const [currentPage, setCurrentPage] = useState(0);
    
        const filteredData = companies.filter((item) =>
          item.Company_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    
        const offset = currentPage * itemsPerPage;
        const currentItems = filteredData.slice(offset, offset + itemsPerPage);
        const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    
        const handlePageClick = ({ selected }) => {
          setCurrentPage(selected);
        };
        function searchTable(){
          var rows = document.querySelectorAll('#productstable tbody tr');
          var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
          rows.forEach(function(row) {
            var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
            row.style.display = text.includes(val) ? '' : 'none';
          });
        }
        const [isFilterOpen, setIsFilterOpen] = useState(false);

        const toggleFilter = () => setIsFilterOpen(!isFilterOpen);
        const [Industry,setIndustry] = useState("");
        const [Status,setStatus] = useState("");

        const clearFilters = () => {
          setIndustry("");
          setStatus("");
          toggleFilter();
        };
        function applyFilters() {
            axios.get(`${url.path}/filter_companies/`,{
                params:{
                    industry:Industry,
                statu:Status
                }
            })
            .then((res) =>{
                if(res.data.status){
                    var cmp = res.data.companies;
                    setCompanies([])
                    cmp.map((p)=>{
                        setCompanies((prevState) =>[
                            ...prevState, p
                        ])
                    })
                }
            }).catch((err) => {
                console.log("ERROR", err);
              });
        }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>All Companies</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
            <div className="table-container">
            
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            <div style={{ position: "relative",marginLeft:'auto' }}>
              <button className="filter-button" onClick={toggleFilter}>
                Filter <span>▼</span>
              </button>
              {isFilterOpen && (
                <div className="filter-panel">
                  <div>
                    <label>Industry Type:</label>
                    <select name="company"  value={Industry} onChange={(e) =>setIndustry(e.target.value)}>
                      <option value="all">All</option>
                      <option value="Tech">Tech</option>
                      <option value="IT">IT</option>
                      <option value="Business">Business</option>
                    </select>
                  </div>
                  <div>
                    <label>Status:</label>
                    <select name="graduation" value={Status} onChange={(e) =>setStatus(e.target.value)}>
                      <option value="all">All</option>
                      <option value="Accepted">Accepted</option>
                      <option value="Rejected">Rejected</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </div>
                  <div className="filter-actions">
                    <button onClick={clearFilters}>Clear</button>
                    <button onClick={applyFilters}>Apply</button>
                  </div>
                </div>
              )}
            </div>
          </div>
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Industry</th>
            <th>Status</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Company_name}</td>
              <td>{i.Email}</td>
              <td>{i.Contact_number}</td>
              <td>{i.Industry_type}</td>
                <td>{i.Admin_approved}</td>
                <td>{i.Rejection_reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default AllCompaniesPage;